<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  (onHide)="onHide()"
  styleClass="crm-segment-manage-contacts-dialog"
  [style]="{ width: '560px', maxWidth: '95vw' }">

  <ng-template #header>
    <div class="d-flex align-items-center gap-2">
      <i class="pi pi-users" style="font-size: 1.25rem; color: var(--acx-primary)"></i>
      <span class="fw-semibold">
        {{ 'Settings::CRM:Definitions:ManageContacts' | abpLocalization }} &mdash; {{ segment?.name }}
      </span>
    </div>
  </ng-template>

  <!-- Loading state -->
  <div *ngIf="loading" class="text-center py-4">
    <i class="pi pi-spin pi-spinner fs-4"></i>
  </div>

  <ng-container *ngIf="!loading">
    <!-- Already assigned section -->
    <div *ngIf="assignedCount > 0" class="mb-3">
      <div
        class="d-flex align-items-center justify-content-between border px-3 py-2"
        [class.rounded]="!isAssignedExpanded"
        [class.rounded-top]="isAssignedExpanded"
        [class.border-bottom-0]="isAssignedExpanded"
        role="button"
        tabindex="0"
        (click)="isAssignedExpanded = !isAssignedExpanded"
        (keydown.enter)="isAssignedExpanded = !isAssignedExpanded"
        (keydown.space)="$event.preventDefault(); isAssignedExpanded = !isAssignedExpanded">
        <div class="d-flex align-items-center gap-2">
          <i class="pi" [class.pi-chevron-right]="!isAssignedExpanded" [class.pi-chevron-down]="isAssignedExpanded"></i>
          <span class="fw-semibold small">
            {{ 'Settings::CRM:Definitions:AlreadyAssigned' | abpLocalization }}
            ({{ assignedCount }})
          </span>
        </div>
        <button
          type="button"
          class="btn btn-outline-danger btn-sm"
          (click)="$event.stopPropagation(); onUnassignAll()">
          <i class="pi pi-user-minus me-1"></i>
          {{ 'Settings::CRM:Definitions:UnassignAll' | abpLocalization }}
        </button>
      </div>

      <div
        *ngIf="isAssignedExpanded"
        class="border border-top-0 rounded-bottom px-2 pt-1 overflow-auto"
        style="max-height: 240px"
        (scroll)="onAssignedScroll($event)">
        <div
          *ngFor="let row of alreadyAssigned; trackBy: trackById; let i = index; let last = last"
          class="d-flex align-items-center gap-2 py-2"
          [class.border-bottom]="!last">
          <span class="badge text-bg-secondary flex-shrink-0">
            {{ 'Settings::CRM:Definitions:Assigned' | abpLocalization }}
          </span>
          <ng-container *ngTemplateOutlet="contactInfo; context: { $implicit: row }"></ng-container>
          <button
            type="button"
            class="btn btn-link p-0 text-muted flex-shrink-0"
            (click)="onRemoveAssigned(i)">
            <i class="pi pi-times"></i>
          </button>
        </div>
        <div *ngIf="assignedLoadingMore" class="text-center py-2 text-muted">
          <i class="pi pi-spin pi-spinner"></i>
        </div>
      </div>
    </div>

    <!-- Contact selector row -->
    <div class="d-flex gap-2 mb-3">
      <div class="flex-grow-1 min-w-0">
        <cx-multi-select
          [options]="availableContactOptions"
          [(ngModel)]="selectedContactIds"
          optionLabel="fullName"
          optionValue="id"
          [filter]="true"
          [filterMatchMode]="serverSideFilterMode"
          [loading]="pickerLoading"
          [virtualScroll]="true"
          [virtualScrollItemSize]="52"
          [lazy]="true"
          (filterChange)="onSearch($event)"
          (lazyLoad)="onPickerLazyLoad($event)"
          scrollHeight="260px"
          [maxSelectedLabels]="0"
          [selectedItemsLabel]="contactsSelectedLabel"
          [itemTemplate]="contactInfo"
          [placeholder]="'Settings::CRM:Definitions:SelectContacts' | abpLocalization"
          class="w-100 d-block"
          styleClass="w-100">
        </cx-multi-select>
      </div>
      <button
        type="button"
        class="btn btn-primary btn-sm text-nowrap"
        [disabled]="!selectedContactIds.length"
        (click)="onAdd()">
        <i class="pi pi-plus me-1"></i>
        {{ 'Settings::CRM:Definitions:Add' | abpLocalization }}
      </button>
    </div>

    <!-- New contacts section -->
    <ng-container *ngIf="newContacts.length > 0">
      <div class="fw-semibold small mb-2">
        {{ 'Settings::CRM:Definitions:New' | abpLocalization }} ({{ newContacts.length }})
      </div>

      <div class="overflow-auto" style="max-height: 240px">
        <div
          *ngFor="let row of newContacts; trackBy: trackById; let i = index; let last = last"
          class="d-flex align-items-center gap-2 py-2"
          [class.border-bottom]="!last">
          <span class="badge text-bg-success text-white flex-shrink-0">
            {{ 'Settings::CRM:Definitions:New' | abpLocalization }}
          </span>
          <ng-container *ngTemplateOutlet="contactInfo; context: { $implicit: row }"></ng-container>
          <button
            type="button"
            class="btn btn-link p-0 text-muted flex-shrink-0"
            (click)="onRemoveNew(i)">
            <i class="pi pi-times"></i>
          </button>
        </div>
      </div>
    </ng-container>

    <!-- Empty state -->
    <div
      *ngIf="assignedCount === 0 && newContacts.length === 0"
      class="text-center py-4 text-muted">
      <i class="pi pi-users fs-2 d-block mb-2" style="color: var(--acx-border-subtle)"></i>
      <span class="small">{{ 'Settings::CRM:Definitions:NoContactsAssigned' | abpLocalization }}</span>
    </div>
  </ng-container>

  <ng-template #footer>
    <cx-form-actions
      layout="dialog"
      cancelVariant="outline-secondary"
      [cancelLabel]="'AbpUi::Cancel' | abpLocalization"
      [saveLabel]="'AbpUi::Save' | abpLocalization"
      saveType="button"
      [disabled]="!canSave || saving"
      [isSubmitting]="saving"
      (cancel)="onCancel()"
      (save)="onSave()">
    </cx-form-actions>
  </ng-template>
</p-dialog>

<!-- Name on top, default phone number below: used by the dropdown options and the list rows. -->
<ng-template #contactInfo let-row>
  <div class="flex-grow-1 min-w-0 lh-sm">
    <div class="small text-truncate">{{ row.fullName }}</div>
    <div *ngIf="row.phoneNumber" class="small text-muted text-truncate">{{ row.phoneNumber }}</div>
  </div>
</ng-template>
